/* ------------------------------------------------------------------------------
 *
 *  # Sidebar Components Module
 *
 *  All sidebar related functionality
 *
 * ---------------------------------------------------------------------------- */

// Resize main sidebar
export function sidebarMainResize() {
    // Elements
    const sidebarMainElement = document.querySelector('.sidebar-main'),
        sidebarMainToggler = document.querySelectorAll('.sidebar-main-resize'),
        resizeClass = 'sidebar-main-resized',
        unfoldClass = 'sidebar-main-unfold';

    // Config
    if (sidebarMainElement) {
        // Define variables
        const unfoldDelay = 150;
        let timerStart,
            timerFinish;

        // Toggle classes on click
        sidebarMainToggler.forEach(function (toggler) {
            toggler.addEventListener('click', function (e) {
                e.preventDefault();
                sidebarMainElement.classList.toggle(resizeClass);
                !sidebarMainElement.classList.contains(resizeClass) && sidebarMainElement.classList.remove(unfoldClass);
            });
        });

        // Add class on mouse enter
        sidebarMainElement.addEventListener('mouseenter', function () {
            clearTimeout(timerFinish);
            timerStart = setTimeout(function () {
                sidebarMainElement.classList.contains(resizeClass) && sidebarMainElement.classList.add(unfoldClass);
            }, unfoldDelay);
        });

        // Remove class on mouse leave
        sidebarMainElement.addEventListener('mouseleave', function () {
            clearTimeout(timerStart);
            timerFinish = setTimeout(function () {
                sidebarMainElement.classList.remove(unfoldClass);
            }, unfoldDelay);
        });
    }
}

// Toggle main sidebar
export function sidebarMainToggle() {
    // Elements
    const sidebarMainElement = document.querySelector('.sidebar-main'),
        sidebarMainRestElements = document.querySelectorAll('.sidebar:not(.sidebar-main):not(.sidebar-component)'),
        sidebarMainDesktopToggler = document.querySelectorAll('.sidebar-main-toggle'),
        sidebarMainMobileToggler = document.querySelectorAll('.sidebar-mobile-main-toggle'),
        sidebarCollapsedClass = 'sidebar-collapsed',
        sidebarMobileExpandedClass = 'sidebar-mobile-expanded';

    // On desktop
    sidebarMainDesktopToggler.forEach(function (toggler) {
        toggler.addEventListener('click', function (e) {
            e.preventDefault();
            sidebarMainElement.classList.toggle(sidebarCollapsedClass);
        });
    });

    // On mobile
    sidebarMainMobileToggler.forEach(function (toggler) {
        toggler.addEventListener('click', function (e) {
            e.preventDefault();
            sidebarMainElement.classList.toggle(sidebarMobileExpandedClass);

            sidebarMainRestElements.forEach(function (sidebars) {
                sidebars.classList.remove(sidebarMobileExpandedClass);
            });
        });
    });
}

// Toggle secondary sidebar
export function sidebarSecondaryToggle() {
    // Elements
    const sidebarSecondaryElement = document.querySelector('.sidebar-secondary'),
        sidebarSecondaryRestElements = document.querySelectorAll('.sidebar:not(.sidebar-secondary):not(.sidebar-component)'),
        sidebarSecondaryDesktopToggler = document.querySelectorAll('.sidebar-secondary-toggle'),
        sidebarSecondaryMobileToggler = document.querySelectorAll('.sidebar-mobile-secondary-toggle'),
        sidebarCollapsedClass = 'sidebar-collapsed',
        sidebarMobileExpandedClass = 'sidebar-mobile-expanded';

    // On desktop
    sidebarSecondaryDesktopToggler.forEach(function (toggler) {
        toggler.addEventListener('click', function (e) {
            e.preventDefault();
            sidebarSecondaryElement.classList.toggle(sidebarCollapsedClass);
        });
    });

    // On mobile
    sidebarSecondaryMobileToggler.forEach(function (toggler) {
        toggler.addEventListener('click', function (e) {
            e.preventDefault();
            sidebarSecondaryElement.classList.toggle(sidebarMobileExpandedClass);

            sidebarSecondaryRestElements.forEach(function (sidebars) {
                sidebars.classList.remove(sidebarMobileExpandedClass);
            });
        });
    });
}

// Toggle right sidebar
export function sidebarRightToggle() {
    // Elements
    const sidebarRightElement = document.querySelector('.sidebar-end'),
        sidebarRightRestElements = document.querySelectorAll('.sidebar:not(.sidebar-end):not(.sidebar-component)'),
        sidebarRightDesktopToggler = document.querySelectorAll('.sidebar-end-toggle'),
        sidebarRightMobileToggler = document.querySelectorAll('.sidebar-mobile-end-toggle'),
        sidebarCollapsedClass = 'sidebar-collapsed',
        sidebarMobileExpandedClass = 'sidebar-mobile-expanded';

    // On desktop
    sidebarRightDesktopToggler.forEach(function (toggler) {
        toggler.addEventListener('click', function (e) {
            e.preventDefault();
            sidebarRightElement.classList.toggle(sidebarCollapsedClass);
        });
    });

    // On mobile
    sidebarRightMobileToggler.forEach(function (toggler) {
        toggler.addEventListener('click', function (e) {
            e.preventDefault();
            sidebarRightElement.classList.toggle(sidebarMobileExpandedClass);

            sidebarRightRestElements.forEach(function (sidebars) {
                sidebars.classList.remove(sidebarMobileExpandedClass);
            });
        });
    });
}

// Toggle component sidebar
export function sidebarComponentToggle() {
    // Elements
    const sidebarComponentElement = document.querySelector('.sidebar-component'),
        sidebarComponentMobileToggler = document.querySelectorAll('.sidebar-mobile-component-toggle'),
        sidebarMobileExpandedClass = 'sidebar-mobile-expanded';

    // Toggle classes
    sidebarComponentMobileToggler.forEach(function (toggler) {
        toggler.addEventListener('click', function (e) {
            e.preventDefault();
            sidebarComponentElement.classList.toggle(sidebarMobileExpandedClass);
        });
    });
}
